import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ReferralCodeCard = ({ code, usesCount = 0, onCopy, onShare }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    onCopy?.();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const referralUrl = `${window?.location?.origin}/register?ref=${code}`;

  const handleCopyUrl = () => {
    navigator?.clipboard?.writeText(referralUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-gradient-to-br from-primary/10 via-accent/5 to-success/10 border border-primary/20 rounded-lg shadow-lg p-6 md:p-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        {/* Code Display */}
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Gift" size={20} color="var(--color-primary)" />
            <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
              Your Referral Code
            </h3>
          </div>
          <div className="flex items-center gap-3 mb-3">
            <div className="bg-background border-2 border-primary/30 rounded-lg px-6 py-3">
              <span className="text-3xl md:text-4xl font-bold font-mono text-primary tracking-wider">
                {code || 'LOADING...'}
              </span>
            </div>
            <Button
              variant="outline"
              size="icon"
              onClick={handleCopy}
              className="h-12 w-12"
            >
              <Icon name={copied ? 'Check' : 'Copy'} size={20} />
            </Button>
          </div>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <Icon name="Users" size={14} />
              <span>{usesCount} uses</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Link" size={14} />
              <span className="truncate max-w-[200px]">{referralUrl}</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            onClick={handleCopyUrl}
            iconName="Link"
            className="flex-1 sm:flex-none"
          >
            Copy Link
          </Button>
          <Button
            onClick={onShare}
            iconName="Share2"
            className="flex-1 sm:flex-none"
          >
            Share
          </Button>
        </div>
      </div>

      {/* Info Banner */}
      <div className="mt-6 pt-6 border-t border-primary/20">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <Icon name="Info" size={16} color="var(--color-primary)" />
          </div>
          <div className="text-sm text-muted-foreground">
            <p className="font-medium text-foreground mb-1">How it works:</p>
            <p>
              Share your unique referral code with friends. When they sign up and become active members,
              you will earn rewards! Track your referrals and rewards in real-time.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralCodeCard;